// Two-domain mode: marketing on neetone.ai, logged-in app on app.neetone.ai.
// Values come from the backend at runtime (GET /api/config) so they can be changed
// per environment without a rebuild. When either is empty, everything runs on one origin.
let MARKETING = "";
let APP = "";

const trim = (v) => (v || "").replace(/\/$/, "");

export const initDomains = ({ marketing_url, app_url } = {}) => {
  MARKETING = trim(marketing_url);
  APP = trim(app_url);
};

export const splitMode = () => Boolean(MARKETING && APP);

export const isAppHost = () => splitMode() && trim(window.location.origin) === APP;

// Paths that belong to the logged-in app domain.
const APP_PATHS = ["/app", "/login", "/admin", "/phone-gate"];
const isAppPath = (path) => APP_PATHS.some((p) => path === p || path.startsWith(`${p}/`));

// Absolute link to a path on the right domain (relative path in single-domain mode).
export const appUrl = (path) => (splitMode() ? `${APP}${path}` : path);
export const marketingUrl = (path = "/") => (splitMode() ? `${MARKETING}${path}` : path);

// The URL a path should live on, or null when the current origin is already correct.
export const crossDomainRedirect = () => {
  if (!splitMode()) return null;
  // On the app host, "/" and unknown paths are handled by the router (it sends them to /app).
  if (isAppHost()) return null;
  const { pathname, search, hash } = window.location;
  if (isAppPath(pathname)) return `${APP}${pathname}${search || ""}${hash || ""}`;
  return null;
};
